export const ADD_PEDIDOS = 'ADD_PEDIDOS';
export const UPDATE_PEDIDO = 'UPDATE_PEDIDO';
export const CLEAR_PEDIDOS = 'CLEAR_PEDIDOS';
export const ADD_CAPACIDADES = 'ADD_CAPACIDADES';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SET_PVS = 'SET_PVS';
export const SET_PVS_PEDIDOS = 'SET_PVS_PEDIDOS';
export const SET_PV_ATUAL = 'SET_PV_ATUAL';
export const SET_DIAS_UTEIS = 'SET_DIAS_UTEIS';
export const SET_DIAS_UTEIS_ATUAL = 'SET_DIAS_UTEIS_ATUAL';
export const SET_CURRENT_DATA_PV = 'SET_CURRENT_DATA_PV';
export const CLEAR_CURRENT_DATA_PV = 'CLEAR_CURRENT_DATA_PV';
export const SET_CURRENT_FACCAO = 'SET_CURRENT_FACCAO';
export const SET_DIAS_SEMANA = 'SET_DIAS_SEMANA';
export const SET_SOMATORIO_DIAS = 'SET_SOMATORIO_DIAS';
export const SET_SOMATORIO_DIAS_TODAS = 'SET_SOMATORIO_DIAS_TODAS';
export const SET_DATA_TODOS = 'SET_DATA_TODOS';
export const SET_PIOR_DATA = 'SET_PIOR_DATA';
export const CLEAR_DATA_TODOS = 'CLEAR_DATA_TODOS';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_WARNING = 'SHOW_WARNING';
export const SHOW_ERROR = 'SHOW_ERROR';
export const SET_ANT_DATA_PV = 'SET_ANT_DATA_PV';
export const SET_POST_DATA_PV = 'SET_POST_DATA_PV';
export const SET_DATA_INDICE_QUALIDADE = 'SET_DATA_INDICE_QUALIDADE';
export const ADD_SOMATORIO = 'ADD_SOMATORIO';
export const CLEAR_SOMATORIO = 'CLEAR_SOMATORIO';
export const SET_CLEAR_SOMATORIO_DIAS_TODAS = 'SET_CLEAR_SOMATORIO_DIAS_TODAS';
export const ADD_LOAD = 'ADD_LOADED';
export const CLEAR_LOAD = 'CLEAR_LOADED';
export const IS_HOME = 'IS_HOME';
export const IS_NOT_HOME = 'IS_NOT_HOME';
export const SET_VERSAO = 'SET_VERSAO';
export const SET_CALENDARIO = 'SET_CALENDARIO';
export const SET_FACTION_FILTERS = 'SET_FACTION_FILTERS';
